import { Overlay, OverlayPositionBuilder, OverlayRef } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { TitleCasePipe } from "@angular/common";
import { Component, inject, TemplateRef, ViewContainerRef } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { AppService } from "src/app-legacy/core/services/app.service";
import { AvatarInitialsComponent } from "src/app/shared/components/avatar-initials/avatar-initials.component";
import { TopbarUserProfileMenuComponent } from "../topbar-user-profile-menu/topbar-user-profile-menu.component";

@Component({
	selector: "app-topbar-user-profile",
	imports: [AvatarInitialsComponent, MatIcon, TitleCasePipe, TopbarUserProfileMenuComponent],
	templateUrl: "./topbar-user-profile.component.html",
})
export class TopbarUserProfileComponent {
	private app = inject(AppService);
	private overlay = inject(Overlay);
	private overlayPositionBuilder = inject(OverlayPositionBuilder);
	private vcr = inject(ViewContainerRef);

	user = this.app.currentUser.user;

	private overlayRef!: OverlayRef;
	isOpen = false;

	openDropdown(triggerElement: HTMLElement, templateRef: TemplateRef<unknown>): void {
		const positionStrategy = this.overlayPositionBuilder.flexibleConnectedTo(triggerElement).withPositions([
			{
				originX: "end",
				originY: "bottom",
				overlayX: "end",
				overlayY: "top",
				offsetY: 32,
			},
		]);

		this.overlayRef = this.overlay.create({
			positionStrategy,
			scrollStrategy: this.overlay.scrollStrategies.noop(),
			hasBackdrop: true,
			backdropClass: "tw:bg-sub-menu-backdrop",
		});

		this.overlayRef.attach(new TemplatePortal(templateRef, this.vcr));
		this.overlayRef.backdropClick().subscribe(() => this.closeOverlay());

		this.isOpen = true;
	}

	closeOverlay() {
		if (this.overlayRef) {
			this.isOpen = false;
			this.overlayRef.dispose();
		}
	}
}
